import { useApi } from '@backstage/core-plugin-api';
import useAsync from 'react-use/esm/useAsync';
import { kubernetesApiRef } from '../api/types.esm.js';

const useIsPodExecTerminalSupported = () => {
  const kubernetesApi = useApi(kubernetesApiRef);
  return useAsync(async () => {
    const clusters = await kubernetesApi.getClusters();
    if (clusters.length !== 1) {
      return false;
    }
    const { authProvider } = clusters[0];
    const isClientAuthProvider = ["aks", "google", "oidc"].some(
      (authProviderName) => authProvider.includes(authProviderName)
    );
    return !isClientAuthProvider;
  });
};

export { useIsPodExecTerminalSupported };
//# sourceMappingURL=useIsPodExecTerminalSupported.esm.js.map
